module.exports = __webpack_public_path__ + "media/images/badge/appassionato-323dbea7d4611042b40c70f1415ff275.png";